import React from 'react'
import { Accordion } from 'react-bootstrap'
export default function PhysicalDocsLeft({data}) {
  const [activeKey2, setActiveKey2] = React.useState("0")
  return (
    <>
      <section className="home-document-area physical-docsleft-area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 order-1 order-md-0">
              <div className="home-document-content home-enterprise-content">
                <h3 className="heading">{data?.head}</h3>
                <p>{data?.desc}</p>
                <Accordion activeKey={activeKey2} onSelect={(key) => setActiveKey2(key ?? activeKey2)}>
                  {data?.boxes?.map((item, index) => (
                    <Accordion.Item key={index} eventKey={`${index}`} className={activeKey2 === `${index}` ? "active-accordion" : ""}>
                      <Accordion.Header>{item?.head}</Accordion.Header>
                      <Accordion.Body>{item?.para}</Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 order-0 order-md-1">
              <div className="home-document-img home-enterprise-img">
                 <img src={data?.boxes[activeKey2]?.img}  alt="Redefine"  loading="lazy"/>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}